var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132.47,
    height: 80.53,
    viewBox: "0 0 132.47 80.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M81.68,31.74,76,58.78c-.44,1.91-1.56,2.38-3.17,1.49l-8.73-6.44-4.22,4.05a2.2,2.2,0,0,1-1.76.86l.63-8.9L74.9,35.21c.7-.63-.16-1-1.1-.35l-20,12.6-8.62-2.69c-1.87-.59-1.91-1.88.39-2.78L79.26,29C80.83,28.42,82.19,29.35,81.68,31.74Z",
    fill: "#0069dd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.66,26.56c-1.68,2-5.49,1.14-7.8,2s-4.7,4-7.22,3.6S21,28.09,19,26.4,13.14,24.27,12.28,22,14,16.7,14.45,14.19s-1.2-6,.49-8,5.49-1.15,7.8-2,4.7-4,7.21-3.6,3.6,4.08,5.64,5.76,5.87,2.13,6.73,4.45S40.57,16,40.15,18.51,41.35,24.51,39.66,26.56Z",
    fill: "none",
    stroke: "#0069dd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.58,53.59c2.13,1.25,1.74,5,2.88,7s4.6,3.68,4.59,6.06-3.41,3.87-4.65,6-1,5.86-3,7-5.14-1-7.52-1-5.4,2.19-7.54,1-1.74-5-2.88-7-4.59-3.68-4.58-6.06,3.4-3.87,4.65-6,.94-5.86,3-7,5.15,1,7.52,1S121.45,52.35,123.58,53.59Z",
    fill: "none",
    stroke: "#0069dd"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.08,14.37l2.07,7.72L22.8,25.4l-2.07-7.72",
    fill: "none",
    stroke: "#0069dd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.37,
    y: 12.03,
    width: 16,
    height: 3.93,
    transform: "translate(-2.73 7.31) rotate(-15.01)",
    fill: "none",
    stroke: "#0069dd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.86,
    y1: 23.79,
    x2: 25.74,
    y2: 12.13,
    fill: "none",
    stroke: "#0069dd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.88,12.16l-3.48.94a2,2,0,0,1-1-3.87C24.07,8.51,25.88,12.16,25.88,12.16Z",
    fill: "none",
    stroke: "#0069dd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.87,12.17l3.48-.94a2,2,0,0,0-1-3.86C25.61,8.09,25.87,12.17,25.87,12.17Z",
    fill: "none",
    stroke: "#0069dd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 120.65,
    y1: 60.32,
    x2: 110.96,
    y2: 72.52,
    fill: "none",
    stroke: "#0069dd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.39,
    cy: 61.75,
    r: 2.15,
    fill: "none",
    stroke: "#0069dd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.57,
    cy: 71.45,
    r: 2.15,
    fill: "none",
    stroke: "#0069dd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.63,35.81s-16,13.4-5.65,28.1c6.82,9.69,27.94,6.63,40.25-2.16",
    fill: "none",
    stroke: "#0069dd",
    strokeDasharray: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.87,47.5s9.08-16.31.21-27.62c-7.16-9.13-21.86-10.25-37.67,2",
    fill: "none",
    stroke: "#0069dd",
    strokeDasharray: 8
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.fbc600f3f0d8067781eab7ad78d1d503.svg";
export { ForwardRef as ReactComponent };